<template>
  <basic-container>
    <avue-crud
      v-if="reWrite"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.questionnaireplan_add"
          @click="openQuestionnairePlanAddDialog"
          >新 增
        </el-button>
        <!--            <el-button-->
        <!--              type="danger"-->
        <!--              size="small"-->
        <!--              icon="el-icon-delete"-->
        <!--              plain-->
        <!--              v-if="permission.questionnaireplan_delete"-->
        <!--              @click="handleDelete"-->
        <!--            >删 除-->
        <!--            </el-button>-->
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          v-if="permission.questionnaireplan_view"
          @click="openQuestionnairePlanViewDialog(scope.row)"
          >查看
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          v-if="permission.questionnaireplan_edit"
          @click="openQuestionnairePlanEditDialog(scope.row)"
          >修改
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          v-if="permission.questionnaireplan_delete"
          @click="rowDel(scope.row)"
          >删除
        </el-button>
        <el-button
          type="text"
          size="small"
          icon="el-icon-thumb"
          v-if="permission.questionnaireplan_delete"
          @click="publish(scope.row)"
          >发布
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      width="60%"
      title="新增"
      :visible.sync="openQuestionnairePlanAddDialogFlag"
      v-if="openQuestionnairePlanAddDialogFlag"
      :modal-append-to-body="false"
      append-to-body
      @close="quitQuestionnairePlanAddDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="questionnairePlanAddFormRef"
          v-model="questionnairePlanAddForm"
          :option="questionnairePlanAddOption"
          @submit="questionnairePlanAddSubmit"
        >
          <template slot="test" slot-scope="scope">
            <el-transfer
              filterable
              filter-placeholder="请输入问卷名称"
              :titles="['未选问卷', '目标问卷']"
              :props="{
                key: 'id',
                label: 'name',
              }"
              v-model="addValue"
              :data="questionnaireRepositoryList"
            >
            </el-transfer>
          </template>
          <template slot="userIds">
            <el-input
              readonly
              v-model="questionnairePlanAddForm.userIds"
              style="display: none"
            ></el-input>
            <el-input
              @focus="addUserBox"
              v-model="formUserNames"
              type="textarea"
              autosize
            ></el-input>
          </template>
          <template slot="testLabel" slot-scope="row">
            <span
              ><span style="color: red">*&nbsp;</span
              >题目内容:&nbsp;&nbsp;</span
            >
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitQuestionnairePlanAddDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      width="60%"
      title="修改"
      :visible.sync="openQuestionnairePlanEditDialogFlag"
      v-if="openQuestionnairePlanEditDialogFlag"
      :modal-append-to-body="false"
      append-to-body
      @close="quitQuestionnairePlanEditDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="questionnairePlanEditFormRef"
          v-model="questionnairePlanEditForm"
          :option="questionnairePlanEditOption"
          @submit="questionnairePlanEditSubmit"
        >
          <template slot="userIds" slot-scope="scope">
            <el-input
              readonly
              v-model="questionnairePlanEditForm.userIds"
              style="display: none"
            ></el-input>
            <el-input
              @focus="editUserBox(scope)"
              v-model="formUserNames"
              autosize
              type="textarea"
            ></el-input>
          </template>
          <template slot="test" slot-scope="scope">
            <el-transfer
              filterable
              filter-placeholder="请输入问卷名称"
              :titles="['未选问卷', '目标问卷']"
              :props="{
                key: 'id',
                label: 'name',
              }"
              v-model="editValue"
              :data="questionnaireRepositoryList"
            >
            </el-transfer>
          </template>
          <template slot="testLabel" slot-scope="row">
            <span
              ><span style="color: red">*&nbsp;</span
              >题目内容:&nbsp;&nbsp;</span
            >
          </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button @click="quitQuestionnairePlanEditDialog">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      width="60%"
      title="查看"
      :visible.sync="openQuestionnairePlanViewDialogFlag"
      v-if="openQuestionnairePlanViewDialogFlag"
      :modal-append-to-body="false"
      @close="quitQuestionnairePlanViewDialog"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="questionnairePlanViewFormRef"
          v-model="questionnairePlanViewForm"
          :option="questionnairePlanViewOption"
        >
          <template slot="test" slot-scope="scope">
            <avue-crud :data="viewTopicData" :option="topicOption"></avue-crud>
          </template>
          <template slot="testLabel" slot-scope="row">
            <span>题目内容:&nbsp;&nbsp;</span>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      title="发布任务"
      append-to-body
      :visible.sync="openPublishFlag"
      @close="closePublishDialog"
    >
      <avue-form
        v-model="openPublishForm"
        ref="openPublishFormRef"
        :option="openPublishOption"
        @submit="openPublishSubmit"
      >
      </avue-form>
    </el-dialog>
    <!-- 人员选择 -->
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      append-to-body
      :modal-append-to-body="false"
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible && userEditBoxProjectId"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType="selectUserType"
        :handleAction="handleAction"
        :remainUserListInside="remainUserList"
        :projectId="userEditBoxProjectId"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getPlanTopicIdListByPlanId,
  getPlanTopicListByPlanId,
  getProjectUserList,
} from "@/api/crmedical/questionnaire/plan/questionnaireplan";
import { mapGetters } from "vuex";
import questionnairePlanAddOption from "./questionnaireplan-add-option";
import questionnairePlanEditOption from "./questionnaireplan-edit-option";
import questionnairePlanViewOption from "./questionnaireplan-view-option";
import { getProjectList } from "@/api/crmedical/project/project";
import { getQuestionnaireTopicList } from "@/api/crmedical/questionnaire/topic/questionnaireretopic";
import { createTaskByPlanId } from "@/api/crmedical/questionnaire/task/questionnairetask";

import userEditBox from "@/views/crmedical/group/user-edit-box";

export default {
  components: {
    userEditBox,
  },
  data: function () {
    return {
      //人员选择
      dialogUserEditBoxVisible: false,//显隐
      userEditBoxProjectId: "",//项目id
      selectUserType: "",
      remainUserList: [],
      handleAction: "",
      //人员选择end
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      firstDisplayFlag: false,
      reWrite: false,
      tempProjectId: "",
      projectList: [],
      questionnaireRepositoryList: [],
      addValue: [],
      editValue: [],
      viewTopicData: [],
      questionnairePlanAddForm: {},
      questionnairePlanEditForm: {},
      questionnairePlanViewForm: {},
      questionnairePlanAddOption: questionnairePlanAddOption,
      questionnairePlanEditOption: questionnairePlanEditOption,
      questionnairePlanViewOption: questionnairePlanViewOption,
      openQuestionnairePlanAddDialogFlag: false,
      openQuestionnairePlanEditDialogFlag: false,
      openQuestionnairePlanViewDialogFlag: false,
      option: {
        height: "auto",
        calcHeight: 50,
        tip: false,
        border: true,
        indexLabel: "序号",
        index: true,
        selection: true,
        columnBtn: false,
        refreshBtn: false,
        addBtn: false,
        editBtn: false,
        viewBtn: false,
        delBtn: false,
        searchMenuSpan: 6,
        column: [
          {
            label: "主键",
            prop: "id",
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
          },
          {
            label: "项目名称",
            prop: "projectId",
            type: "tree",
            searchClearable: false,
            search: true,
            dicUrl: "/api/v4ward/project/getProjectList",
            props: { label: "name", value: "id" },
          },
          {
            label: "计划名称",
            prop: "name",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "填报类型",
            prop: "informantType",
            type: "radio",
            dataType: "number",
            search: true,
            dicUrl: "api/blade-system/dict/dictionary?code=informant_type",
            props: { label: "dictValue", value: "dictKey" },
          },
          {
            label: "填报对象",
            prop: "objectNames",
            overHidden: true,
          },
          {
            label: "合格比例（%）",
            prop: "criterionScore",
            maxlength: 6,
            showWordLimit: true,
          },
          {
            label: "填报类型",
            prop: "informantType",
            type: "select",
            dataType: "number",
            dicUrl: "api/blade-system/dict/dictionary?code=informant_type",
            props: { label: "dictValue", value: "dictKey" },
          },
          {
            label: "计算类型",
            prop: "calculateType",
            type: "select",
            dataType: "number",
            dicUrl: "api/blade-system/dict/dictionary?code=calculate_type",
            props: { label: "dictValue", value: "dictKey" },
          },
        ],
      },
      topicOption: {
        calcHeight: 50,
        height: "400",
        indexLabel: "序号",
        page: false,
        border: true,
        addBtn: false,
        selection: false,
        tip: false,
        columnBtn: false,
        refreshBtn: false,
        menuAlign: "center",
        menu: false,
        column: [
          {
            label: "题目名称",
            prop: "name",
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "题目内容",
            prop: "topic",
            span: 24,
            row: 4,
            maxlength: 200,
            showWordLimit: true,
            overHidden: true,
          },
          {
            label: "分值",
            prop: "score",
            maxlength: 6,
            showWordLimit: true,
          },
          {
            label: "排序",
            prop: "sort",
            maxlength: 6,
            showWordLimit: true,
          },
        ],
      },
      //发布任务页面option
      openPublishFlag: false,
      openPublishForm: {},
      planId: "",
      openPublishOption: {
        align: "center",
        addBtn: false,
        emptyBtn: false,
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "发布日期",
            prop: "planTimeRange",
            searchRange: true,
            type: "datetimerange",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss",
            span: 24,
            row: true,
            pickerOptions: {
              disabledDate(time) {
                let dateTime = new Date();
                dateTime = dateTime.setDate(dateTime.getDate() - 1);
                dateTime = new Date(dateTime);
                return time.getTime() < dateTime;
              },
            },
            rules: [
              {
                required: true,
                message: "请选择发布日期",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.questionnaireplan_add, false),
        viewBtn: this.vaildData(this.permission.questionnaireplan_view, false),
        delBtn: this.vaildData(this.permission.questionnaireplan_delete, false),
        editBtn: this.vaildData(this.permission.questionnaireplan_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    //加载列表
    getProjectList({}).then((res) => {
      this.projectList = res.data;
      if (this.projectList.length > 0) {
        this.query.projectId = this.projectList[0].id;
        this.tempProjectId = this.projectList[0].id;
      }
      this.$nextTick(() => {
        this.reWrite = true;
      });
      //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
      this.firstDisplayFlag = true;
    });
  },
  watch: {
    "questionnairePlanAddForm.projectId"(val) {
      // 人员选择器
      this.userEditBoxProjectId = val;
      // 人员选择器end
      if (this.questionnairePlanAddForm.projectId) {
        this.addValue = [];
        //根据项目id获取题库
        getQuestionnaireTopicList({
          projectId: this.questionnairePlanAddForm.projectId,
        }).then((res) => {
          this.questionnaireRepositoryList = res.data;
        });
      }
    },
    "questionnairePlanAddForm.informantType"() {
      console.log(this.questionnairePlanAddOption);
      if (this.questionnairePlanAddForm.informantType === 1) {
        this.findObject(
          this.questionnairePlanAddOption.group[0].column,
          "userIds"
        ).display = false;
        this.findObject(
          this.questionnairePlanAddOption.group[0].column,
          "deptIds"
        ).display = true;
      }
      if (this.questionnairePlanAddForm.informantType === 2) {
        this.findObject(
          this.questionnairePlanAddOption.group[0].column,
          "userIds"
        ).display = true;
        this.findObject(
          this.questionnairePlanAddOption.group[0].column,
          "deptIds"
        ).display = false;
      }
    },
    "questionnairePlanEditForm.informantType"() {
      if (this.questionnairePlanEditForm.informantType === 1) {
        this.findObject(
          this.questionnairePlanEditOption.group[0].column,
          "userIds"
        ).display = false;
        this.findObject(
          this.questionnairePlanEditOption.group[0].column,
          "deptIds"
        ).display = true;
      }
      if (this.questionnairePlanEditForm.informantType === 2) {
        this.findObject(
          this.questionnairePlanEditOption.group[0].column,
          "userIds"
        ).display = true;
        this.findObject(
          this.questionnairePlanEditOption.group[0].column,
          "deptIds"
        ).display = false;
      }
    },
    "questionnairePlanViewForm.informantType"() {
      console.log(this.questionnairePlanViewOption);
      if (this.questionnairePlanViewForm.informantType === 1) {
        this.findObject(
          this.questionnairePlanViewOption.group[0].column,
          "userIds"
        ).display = false;
        this.findObject(
          this.questionnairePlanViewOption.group[0].column,
          "deptIds"
        ).display = true;
      }
      if (this.questionnairePlanViewForm.informantType === 2) {
        this.findObject(
          this.questionnairePlanViewOption.group[0].column,
          "userIds"
        ).display = true;
        this.findObject(
          this.questionnairePlanViewOption.group[0].column,
          "deptIds"
        ).display = false;
      }
    },
  },
  methods: {
    //人员选择器
    handleCloseAction(val) {
      this.dialogUserEditBoxVisible = false;
    },
    handleSubmitAction(val) {
    console.log('val handleSubmitAction==>',val);
      this.formUserNames = val.nameListString;
      this.questionnairePlanAddForm.userIds = val.idListString;
      this.remainUserList  = val.dataSelectedUsers;
      this.dialogUserEditBoxVisible = false;
    },
    handleEditAction(val) {
    console.log('val handleEditAction==>',val);
      this.formUserNames = val.nameListString;
      this.questionnairePlanEditForm.userIds = val.idListString;
      this.remainUserList  = val.dataSelectedUsers;
      this.dialogUserEditBoxVisible = false;
    },
    addUserBox() {
      this.dialogUserEditBoxVisible = true;
    },
    editUserBox(row) {
      this.dialogUserEditBoxVisible = true;
    },
    //人员选择器end
    closePublishDialog() {
      this.$refs.openPublishFormRef.resetForm();
      this.planId = "";
      this.openPublishFlag = false;
    },
    openPublishSubmit(row, done) {
      row.startTime = row.planTimeRange[0];
      row.endTime = row.planTimeRange[1];
      row.planId = this.planId;
      createTaskByPlanId(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.closePublishDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    publish(row) {
      this.planId = row.id;
      this.openPublishFlag = true;
    },
    //提交方法=================================================================
    questionnairePlanEditSubmit(row, done) {
      if (this.editValue.length === 0) {
        this.$message.error("请选择题目内容!");
        done();
        return;
      }
      if (row.informantType === 1) {
        row.objectIds = row.deptIds.join(",");
      }
      if (row.informantType === 2) {
        //人员选择框点击取消的时候需要判断
        row.objectIds = Array.isArray(row.userIds)?row.userIds.join(","):row.userIds;
      }
      row.questionnaireRepositoryIds = this.editValue.join(",");
      update(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.quitQuestionnairePlanEditDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    questionnairePlanAddSubmit(row, done) {
      if (this.addValue.length === 0) {
        this.$message.error("请选择题目内容!");
        done();
        return;
      }
      if (row.informantType === 1) {
        row.objectIds = row.deptIds.join(",");
      }
      if (row.informantType === 2) {
        // row.objectIds = row.userIds.join(",");
        row.objectIds = row.userIds;
      }
      row.questionnaireRepositoryIds = this.addValue.join(",");
      add(row).then(
        () => {
          this.onLoad();
          done();
          this.$message.success("操作成功!");
          this.quitQuestionnairePlanAddDialog();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    //关闭弹窗=================================================================
    quitQuestionnairePlanViewDialog() {
      this.$refs.questionnairePlanViewFormRef.resetForm();
      this.viewTopicData = [];
      this.findObject(
        this.questionnairePlanViewOption.group[0].column,
        "userIds"
      ).display = false;
      this.findObject(
        this.questionnairePlanViewOption.group[0].column,
        "deptIds"
      ).display = false;
      this.openQuestionnairePlanViewDialogFlag = false;
    },
    quitQuestionnairePlanEditDialog() {
      // this.$refs.questionnairePlanEditFormRef.resetForm();
      this.editValue = [];
      this.openQuestionnairePlanEditDialogFlag = false;
    },
    quitQuestionnairePlanAddDialog() {
      this.$refs.questionnairePlanAddFormRef.resetForm();
      this.addValue = [];
      this.findObject(
        this.questionnairePlanAddOption.group[0].column,
        "userIds"
      ).display = false;
      this.findObject(
        this.questionnairePlanAddOption.group[0].column,
        "deptIds"
      ).display = false;
      this.openQuestionnairePlanAddDialogFlag = false;
    },
    //打开弹窗--------------------------------------------------------------------
    openQuestionnairePlanViewDialog(row) {
      setTimeout(() => {
        this.questionnairePlanViewForm = row;
        if (row.informantType === 1) {
          row.deptIds = row.objectIds.split(",");
        }
        if (row.informantType === 2) {
          row.userIds = row.objectIds.split(",");
        }
        //根据计划id获取关联题目
        getPlanTopicListByPlanId({ planId: row.id }).then((res) => {
          this.viewTopicData = res.data;
        });
      }, 200);
      this.openQuestionnairePlanViewDialogFlag = true;
    },
    openQuestionnairePlanEditDialog(row) {
      //人员选择器
      this.userEditBoxProjectId = row.projectId;
      let remainUserList = [];
      let formUserNamesArray = [];
      let users = [];
      if (row.informantType === 2) {
        users = row.objectIds.split(",");
      }
      getProjectUserList({projectId:this.userEditBoxProjectId}).then((resUser) => {
        resUser.data.forEach((item) => {
          if (users.includes(item.id)) {
            remainUserList.push(item);
            formUserNamesArray.push(item.realNameAndPhone);
          }
        });
        this.remainUserList = remainUserList;
        this.handleAction = 2;
        this.selectUserType = 1;
        this.formUserNames = formUserNamesArray.join(",");
        //人员选择器end
        //根据项目id获取题库
        getQuestionnaireTopicList({ projectId: row.projectId }).then((res) => {
          this.questionnaireRepositoryList = res.data;
        });
        setTimeout(() => {
          if (row.informantType === 1) {
            row.deptIds = row.objectIds.split(",");
          }
          if (row.informantType === 2) {
            row.userIds = row.objectIds.split(",");
          }
          this.questionnairePlanEditForm = row;
          getPlanTopicIdListByPlanId({ planId: row.id }).then((res) => {
            this.editValue = res.data;
          });
        }, 200);
        this.openQuestionnairePlanEditDialogFlag = true;
      });
    },
    openQuestionnairePlanAddDialog() {
      //人员选择器
      this.handleAction = 1;
      this.selectUserType = 1;
      this.formUserNames = "";
      this.remainUserList = [];
      this.questionnairePlanAddForm.userIds = "";
      //人员选择器end
      setTimeout(() => {
        this.questionnairePlanAddForm.projectId = this.query.projectId;
      }, 0);
      this.openQuestionnairePlanAddDialogFlag = true;
    },
    getProjectNameById(projectId) {
      let projectName = "";
      this.projectList.forEach(function (value, index, array) {
        if (value.id === projectId) {
          projectName = value.name;
          return;
        }
      });
      return projectName;
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success("操作成功!");
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success("操作成功!");
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query.informantType = "";
      this.query.processStatus = "";
      this.query.name = "";
      this.query.dateStartRange = [];
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      done();
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
      if (!this.query.projectId) {
        this.query.projectId = this.tempProjectId;
      }
      getList(
        Object.assign(
          { current: page.currentPage, size: page.pageSize },
          this.query
        )
      ).then(({ data }) => {
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
        if (this.firstDisplayFlag) {
          let ent = document.querySelector('input[placeholder="项目名称"]');
          ent.value = this.getProjectNameById(this.query.projectId);
          this.tempProjectId = this.query.projectId;
          //关闭默然显示，重刷页面时才开启默认显示
          this.firstDisplayFlag = false;
        }
      });
    },
  },
};
</script>

<style>
</style>
<style lang='scss' scoped>
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 1px);
  max-width: calc(100% - 30px);
}
::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}
</style>
